import { useDispatch } from 'react-redux';
import { ModalConfirm } from '@components/Modal';
import { authActions } from '@actions';
import { useTranslation } from '@hooks';

const LogoutModal = ({ isOpen, setIsOpen, className }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    return (
        <ModalConfirm
            isOpen={isOpen}
            className={className}
            handleClose={() => setIsOpen(false)}
            title={t('LogoutModal.logOutConfirmation')}
            description={t('LogoutModal.logOutConfirmationDescription')}
            onPrimaryAction={() => {
                setIsOpen(false);
                dispatch(authActions.logout());
            }}
            primaryActionText={t('buttons.logout')}
            primaryActionType="danger"
            isLogout
        />
    );
};

export default LogoutModal;
